import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { AssignmentModel } from "../Assignments Model/assignment-data.model";

export class TrainersViewGridModel extends AssignmentModel { }

export class TrainersViewListingModel extends GridModel<TrainersViewGridModel> { }

export class TrainersViewGridParams extends GridPostParams {
    // pageNumber: any = 1;
    // pageSize: any = 10;
    id: any = 3031;
    // assignment_id: any = 348;
    // timeslot_id: any = 846;
  }